export default function getResource(label) {
    const resources = {
        noProducts: 'Sorry, no products match the applied filters.',
        showMore: 'Show more',
        showLess: 'Show less'
    };

    return resources[label];
}
